module.exports = __webpack_public_path__ + "img/ic_home_aI@2x.ccd68aa.png";